import React from 'react'
import { Row, Col } from 'antd'
import Sidebar from './Sidebar'
import { useSession } from '@slerp/accounts'
import { useLocation } from 'react-router-dom'
import GeneralSettings from './GeneralSettings'
import AnalyticsSettings from './AnalyticsSettings'
import Delivery from './Delivery'
import { CONNECT_AND_UPDATE_STRIPE_SETTINGS } from './actions'
import styled from '@emotion/styled'
import MerchantAdminUsersSettings from './MerchantAdminUsersSettings'
import TermsAndConditions from './TermsAndConditions'
import AccountsAndBilling from './AccountsAndBilling'
import { StripeConnectRoute } from 'components/Utils/Stripe'

const Settings = () => {
  const { merchant } = useSession()
  const location = useLocation()

  return (
    <>
      <Row data-testid='settings-component'>
        <SideBarWrapper>
          <Sidebar />
        </SideBarWrapper>
      </Row>
      <Row style={{ backgroundColor: '#ffffff', paddingBottom: '32px' }}>
        <Col span={24} className='_pl-16'>
          {location.pathname.endsWith('/settings/stripe/connect') && (
            <StripeConnectRoute
              path='/stripe/connect'
              redirectUrl='/settings/accounts-and-billing'
              connectMutation={CONNECT_AND_UPDATE_STRIPE_SETTINGS}
              connectVariables={{ merchantId: merchant?.id || '' }}
            />
          )}

          {location.pathname.endsWith('/settings/delivery') && <Delivery />}

          {location.pathname.endsWith('/settings/general') && (
            <GeneralSettings />
          )}

          {location.pathname.endsWith('/settings/analytics') && (
            <AnalyticsSettings />
          )}

          {location.pathname.includes('/settings/terms-and-conditions') && (
            <TermsAndConditions />
          )}

          {location.pathname.includes('/settings/accounts-and-billing') && (
            <AccountsAndBilling />
          )}

          {location.pathname.includes('/settings/users') && (
            <MerchantAdminUsersSettings />
          )}
        </Col>
      </Row>
    </>
  )
}

const SideBarWrapper = styled.div(() => ({
  padding: '0',
  width: '100%'
}))

export default Settings
